import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { u as p } from "../../chunks/use-sitecore-context.C7g4vcbm.js";
import { NeuSpacing as x } from "@hcahealthcaredpx/neutron-react";
import { Text as r } from "@sitecore-jss/sitecore-jss-nextjs";
import { B as f } from "../../chunks/button-link.Cv6YTl23.js";
import { S as d } from "../../chunks/Section.SS-Irndy.js";
const k = ({ rendering: o }) => {
  var a, n, s;
  const { sitecoreContext: c } = p(), e = (a = c.route) == null ? void 0 : a.fields;
  return e ? /* @__PURE__ */ t(d, { dataTestId: o == null ? void 0 : o.componentName, children: /* @__PURE__ */ t("div", { className: "text-centered py-6", children: /* @__PURE__ */ l(x, { size: "md", kind: "expanded", children: [
    /* @__PURE__ */ t(
      r,
      {
        tag: "h2",
        field: e.errorTitle,
        className: "neu-display-2 text-center neu-text-support-60 fw-bold max-w-336 mx-auto"
      }
    ),
    /* @__PURE__ */ t(
      r,
      {
        tag: "p",
        field: e == null ? void 0 : e.errorDescription,
        className: "neu-text-body mb-2 text-center"
      }
    ),
    ((n = e == null ? void 0 : e.errorLinks) == null ? void 0 : n.value) && /* @__PURE__ */ t("div", { className: "d-flex flex-column flex-lg-row justify-content-center gap-2", children: (s = e.errorLinks) == null ? void 0 : s.value.map((i, m) => /* @__PURE__ */ t(f, { field: i }, m)) }),
    /* @__PURE__ */ t(
      r,
      {
        tag: "p",
        field: e == null ? void 0 : e.errorCodeMessage,
        className: "neu-text-body fw-bold text-center"
      }
    )
  ] }) }) }) : null;
};
export {
  k as NotFoundDetailsSection
};
